import { useEffect, useRef, useState } from "react";
import "./ProductsLoadingAnimation.scss";
import { FaceAnalysisAnimation } from "./FaceAnalysisAnimation";
import { ProductBottleBubbleAnimation } from "./ProductBottleBubbleAnimation";
import { useTranslation } from "react-i18next";

export const ProductsLoadingAnimation = ({ apiPromise, onFinish }) => {
  const { t } = useTranslation("productModule");
  const [step, setStep] = useState(0);
  const [isApiRequestComplete, setIsApiRequestComplete] = useState(false);
  const apiPromiseRef = useRef(apiPromise);

  useEffect(() => {
    apiPromiseRef.current().then(() => setIsApiRequestComplete(true));
  }, []);

  return (
    <div className="product-loading-animation-page">
      <div className="product-loading-upper-section">
        {step === 0 && <FaceAnalysisAnimation onDone={() => setStep(1)} />}
        {step === 1 && (
          <ProductBottleBubbleAnimation
            isApiRequestComplete={isApiRequestComplete}
            onDone={onFinish}
          />
        )}
      </div>
      <div className="product-loading-bottom-section">
        <div className="product-loading-boxes-wrapper">
          <div className={`product-loading-box black-filled`} />
          <div
            className={`product-loading-box ${step > 0 ? "black-filled" : ""}`}
          />
        </div>
        <p className="product-loading-animation-text">
          {step === 0
            ? t("loading-animation-analysis-complete")
            : t("loading-animation-matching-products")}
        </p>
      </div>
    </div>
  );
};
